module.exports = __webpack_public_path__ + "img/seckill.00f3b2ff.svg";